var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('legend', [_vm._v("Show Agent Handover/Return Shipments")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate",
      "required": ""
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "change": function($event) {
        return _vm.fromDateChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.fromDate')),
      expression: "errors.has('form-2.fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select From Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "required": ""
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "change": function($event) {
        return _vm.onDateChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.toDate')),
      expression: "errors.has('form-2.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processmode),
      expression: "processmode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-2.processmode')
    },
    attrs: {
      "name": "processmode",
      "id": "processmode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.processmode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Process Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Handover",
      "selected": ""
    }
  }, [_vm._v("Handover")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Return"
    }
  }, [_vm._v("Return")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.processmode')),
      expression: "errors.has('form-2.processmode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Process Mode")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-2.status')
    },
    attrs: {
      "name": "status",
      "id": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.statusOnChange()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _vm._l((_vm.statusArray), function(statusCode) {
    return _c('option', {
      domProps: {
        "value": statusCode.status
      }
    }, [_vm._v(_vm._s(statusCode.status))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.status')),
      expression: "errors.has('form-2.status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Status")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {}, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadShipmentData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Export ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    on: {
      "click": _vm.resetForm
    }
  }), _vm._v(" Reset ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [_c('vue-element-loading', {
    staticStyle: {
      "background-color": "transparent"
    },
    attrs: {
      "spinner": "spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)])])])])]), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length != 0)) ? [_c('div', {}, [_c('legend', [_vm._v("Handover-Details")]), _vm._v(" "), _c('b-card', [_c('div', {
    class: {
      row: true,
      tableFixHead: true
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Super Agent Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehical Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Handover Person Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Is Active")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [(_vm.returnArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Handover shipments not found.")])]) : _vm._l((this.returnArray), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.couriercompanyname))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(data.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.handovermode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.handoverpersonname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.isactive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), (data.createddate) ? _c('td', [_vm._v("\n                  " + _vm._s(data.createddate.replace(/T/, " ")
      .replace(/\..+/, "")) + "\n                ")]) : _vm._e()])
  })], 2)])])])], 1)] : _vm._e()], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("From Date"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("To Date"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Process Mode"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Status"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-433a2221","hasScoped":true}!./src/views/components/agentShowHandOverReturnShipment/agentShowHandOverReturnShipment.component.html
// module id = 1047
// module chunks = 1